import { render } from "./IdsSection.vue?vue&type=template&id=36cf5317"
import script from "./IdsSection.vue?vue&type=script&lang=js"
export * from "./IdsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__